/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol, Button, VisualOnlyLabel, Counter } from 'sarsaparilla';

const propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    isLabelRequired: PropTypes.bool,
};

export default function TempForm(props) {
    return (
        <FlexRow>
            <FlexCol xs={6} md={4}>
                <div className="rec-form-item-wrap">
                    <VisualOnlyLabel isRequired={props.isLabelRequired}>
                        # of Selections
                    </VisualOnlyLabel>
                    <Counter
                        id="simple-form-number"
                        count={props.value}
                        max={props.maxValue}
                        min={props.minValue}
                        onCountChange={(ct) => props.onChange(ct)}
                    />
                </div>
            </FlexCol>
            <FlexCol xs={6} md={8} alignSelf="end">
                <div className="rec-form-item-wrap">
                    <Button onClick={props.onSubmit}>Enter Choices</Button>
                </div>
            </FlexCol>
        </FlexRow>
    );
}

TempForm.defaultProps = {
    maxValue: 99,
    minValue: 0,
    isLabelRequired: false,
};

TempForm.propTypes = propTypes;
